<template>
	<div class="pb-8 text-2xl font-bold text-white flex items-center justify-between flex-wrap">
		<slot />
		<span v-if="route.meta.paginated" class="bg-gray-800 rounded-md py-1 px-3 text-base text-gray-500">Page {{ route.params.page || 1 }}</span>
	</div>
</template>

<script lang="ts" setup>

import {useRoute} from 'vue-router'

const route = useRoute()

</script>
